import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
    name: 'translateSeedData',
    standalone: true
})
export class TranslateSeedDataPipe implements PipeTransform {
    transform(
        value: string,
        langKey: string,
        list: {
            ItemId: string;
            Key?: string;
            Label: { Key: string; Value: string }[];
        }[],
        isKeyCheck: boolean
    ): any {
        if (!value || value === '' || !list || list.length == 0) {
            return '';
        }
        langKey = CommonService.getLanguageKeyFromLang(langKey);

        const item = list.find(item => {
            return isKeyCheck ? item.Key === value : item.ItemId === value;
        });
        const label = item?.Label?.find(label => label.Key === langKey);
        return label?.Value || '';
    }
}
